export interface SubCategoryNeed {
  need_id: string;
  label: string;
  work_type?: string;
}

export const SUBCATEGORY_NEEDS = {
  'Plumbers': [
    {
      need_id: '10000-10064',
      label: 'Backflow Preventers'
    },
    {
      need_id: '10000-14646',
      label: 'Commercial Plumbing'
    },
    {
      need_id: '10000-10017',
      label: 'Drain Cleaning/Unclogging'
    },
    {
      need_id: '10000-10048',
      label: 'Fixtures Installed'
    },
    {
      need_id: '10000-10049',
      label: 'Floor & Laundry Drains'
    },
    {
      need_id: '10000-10050',
      label: 'Frozen Pipes & Drains Thawed'
    },
    {
      need_id: '10000-10051',
      label: 'Garbage Disposals'
    },
    {
      need_id: '10000-10052',
      label: 'Gas Lines Installed & Repaired'
    },
    {
      need_id: '10000-14362',
      label: 'General Plumbing Repair'
    },
    {
      need_id: '10000-10072',
      label: 'Hydro-Jetting Service'
    },
    {
      need_id: '10000-10074',
      label: 'In-line Video Camera Service'
    },
    {
      need_id: '10000-10054',
      label: 'Leaks Detected & Repaired'
    },
    {
      need_id: '10000-10055',
      label: 'Pipe Replacements & Repairs'
    },
    {
      need_id: '10000-10110',
      label: 'Plumbing Inspection'
    },
    {
      need_id: '10000-10077',
      label: 'Plumbing for Mobile Homes'
    },
    {
      need_id: '10000-10078',
      label: 'Pool, Spa & Jacuzzi Service'
    },
    {
      need_id: '10000-10079',
      label: 'Radiant Floor Systems'
    },
    {
      need_id: '10000-10057',
      label: 'Sewer Lines'
    },
    {
      need_id: '10000-10058',
      label: 'Showers & Tubs'
    },
    {
      need_id: '10000-10059',
      label: 'Sinks, Toilets & Faucets'
    },
    {
      need_id: '10000-10060',
      label: 'Sump Pumps Installed & Repaired'
    },
    {
      need_id: '10000-10085',
      label: 'Underground Pipe Repairs'
    },
    {
      need_id: '10000-10061',
      label: 'Water Heaters - Standard'
    },
    {
      need_id: '10000-10062',
      label: 'Water Heaters - Tankless'
    },
    {
      need_id: '10000-10063',
      label: 'Water Lines Installed & Repaired'
    },
    {
      need_id: '10000-10113',
      label: 'Water Pressure Problems'
    },
    {
      need_id: '10000-10086',
      label: 'Water Purification & Filters'
    },
    {
      need_id: '10000-10020',
      label: 'Well Pumps Installed & Repaired'
    },
    {
      need_id: '10000-10117',
      label: 'Winterization'
    }
  ],
  'Roofers': [
    {
      need_id: '11000-10152',
      label: 'Capping/Flashing',
      work_type: 'repair'
    },
    // {
    //     need_id: '11000-14647',
    //     label: 'Commercial Roofing',
    // },
    {
      need_id: '11000-14363',
      label: 'General Roof Repairs',
      work_type: 'repair'
    },
    {
      need_id: '11000-10157',
      label: 'New/Re-Roof - Asphalt Shingle',
      work_type: 'new'
    },
    {
      need_id: '11000-10158',
      label: 'New/Re-Roof - Cedar/Wood',
      work_type: 'new'
    },
    {
      need_id: '11000-10159',
      label: 'New/Re-Roof - Clay/Tile',
      work_type: 'new'
    },
    {
      need_id: '11000-10160',
      label: 'New/Re-Roof - Flat/Rubber/Hot Asphalt',
      work_type: 'new'
    },
    {
      need_id: '11000-10161',
      label: 'New/Re-Roof - Metal',
      work_type: 'new'
    },
    {
      need_id: '11000-10162',
      label: 'New/Re-Roof - Natural Slate',
      work_type: 'new'
    },
    // {
    //     need_id: '11000-14726',
    //     label: 'Residential Roofing',
    // },
    {
      need_id: '11000-10163',
      label: 'Roof Certifications',
      work_type: 'repair'
    },
    // {
    //     need_id: '11000-10164',
    //     label: 'Roof Cleaning',
    // },
    {
      need_id: '11000-10165',
      label: 'Roof Drainage/Repitching',
      work_type: 'repair'
    },
    {
      need_id: '11000-10166',
      label: 'Roof Leak/Repair - Asphalt Shingle',
      work_type: 'repair'
    },
    {
      need_id: '11000-10167',
      label: 'Roof Leak/Repair - Cedar/Wood',
      work_type: 'repair'
    },
    {
      need_id: '11000-10168',
      label: 'Roof Leak/Repair - Clay/Tile',
      work_type: 'repair'
    },
    {
      need_id: '11000-10169',
      label: 'Roof Leak/Repair - Flat/Rubber/Hot Asphalt',
      work_type: 'repair'
    },
    {
      need_id: '11000-10170',
      label: 'Roof Leak/Repair - Metal',
      work_type: 'repair'
    },
    // {
    //     need_id: '11000-10171',
    //     label: 'Roof Leak/Repair - Natural Slate',
    // },
    // {
    //     need_id: '11000-10172',
    //     label: 'Skylights',
    // },
    // {
    //     need_id: '11000-10173',
    //     label: 'Spray Foam Roofing',
    // },
    {
      need_id: '11000-10175',
      label: 'Ventilation/Ridge Vents',
      work_type: 'repair'
    }
  ],
  'Electricians': [
    {
      need_id: '5000-10176',
      label: 'Alarms / Security Systems'
    },
    {
      need_id: '5000-10177',
      label: 'Appliance & A / C Lines'
    },
    {
      need_id: '5000-10178',
      label: 'Attic & Exhaust Fans'
    },
    {
      need_id: '5000-10180',
      label: 'Cable TV Wiring'
    },
    {
      need_id: '5000-10181',
      label: 'Ceiling Fans'
    },
    {
      need_id: '5000-10183',
      label: 'Circuit Breakers / Boxes'
    },
    {
      need_id: '5000-14642',
      label: 'Commercial Electrical Work'
    },
    {
      need_id: '5000-10184',
      label: 'Dedicated Lines'
    },
    {
      need_id: '5000-10186',
      label: 'Electrical Inspections'
    },
    {
      need_id: '5000-10222',
      label: 'Fire / Smoke Alarms'
    },
    {
      need_id: '5000-14366',
      label: 'General Electrical Repairs'
    },
    {
      need_id: '5000-10209',
      label: 'Generators / UPS'
    },
    {
      need_id: '5000-10193',
      label: 'Landscape / Outdoor Lighting'
    },
    {
      need_id: '5000-13217',
      label: 'Lighting Fixture Installation'
    },
    {
      need_id: '5000-10198',
      label: 'Outlets & Switches'
    },
    {
      need_id: '5000-10203',
      label: 'Service Upgrades'
    },
    {
      need_id: '5000-10204',
      label: 'Smart House Wiring'
    },
    {
      need_id: '5000-10206',
      label: 'Surround Sound / Home Theater'
    },
    {
      need_id: '5000-10208',
      label: 'Trouble Shooting / Shorts'
    },
    {
      need_id: '5000-10210',
      label: 'Voice / Data Wiring'
    },
    {
      need_id: '5000-10211',
      label: 'Wiring & Rewiring'
    }
  ],
  'Exterminators': [
    {
      need_id: '6000-14379',
      label: 'Ants'
    },
    {
      need_id: '6000-10141',
      label: 'Bed Bugs'
    },
    {
      need_id: '6000-14373',
      label: 'Bees'
    },
    {
      need_id: '6000-14643',
      label: 'Commercial Pest Control'
    },
    {
      need_id: '6000-14376',
      label: 'Ticks'
    },
    {
      need_id: '6000-12360',
      label: 'Full Service Pest Control'
    },
    {
      need_id: '6000-14367',
      label: 'Mice'
    },
    {
      need_id: '6000-14377',
      label: 'Mosquitos'
    },
    {
      need_id: '6000-10146',
      label: 'Roaches'
    },
    {
      need_id: '6000-10145',
      label: 'Rodents'
    },
    {
      need_id: '6000-12358',
      label: 'Spiders'
    },
    {
      need_id: '6000-12359',
      label: 'Stinging Insects'
    },
    {
      need_id: '6000-10148',
      label: 'Termites'
    },
    {
      need_id: '6000-14731',
      label: 'Fleas'
    },
    {
      need_id: '6000-14368',
      label: 'Rats'
    }
  ],
  'Flea Exterminators': [
    {
      need_id: '6000-14731',
      label: 'Fleas'
    }
  ],
  'Locksmiths': [
    {
      need_id: '173-14080',
      label: '24 Hour Locksmith Service'
    },
    {
      need_id: '173-12095',
      label: 'Car Lockout'
    },
    {
      need_id: '173-14083',
      label: 'Commercial Locksmiths'
    },
    {
      need_id: '173-12096',
      label: 'Complete Locksmith Service'
    },
    {
      need_id: '173-14084',
      label: 'Emergency Locksmiths'
    },
    {
      need_id: '173-14086',
      label: 'Lock Installation'
    }
  ],
  'HVAC Contractors': [
    {
      need_id: '584-14634',
      label: 'Air Ducts - Repair & Replace'
    },
    {
      need_id: '584-14346',
      label: 'Central Air - Cleaning & Maintenance'
    },
    {
      need_id: '584-14344',
      label: 'Central Air - New Install'
    },
    {
      need_id: '584-14345',
      label: 'Central Air - Repair'
    },
    {
      need_id: '584-14347',
      label: 'Commercial Cooling'
    },
    {
      need_id: '584-14349',
      label: 'Ductless Air Conditioning'
    },
    {
      need_id: '584-13218',
      label: 'Thermostats'
    }
  ],
  'Appliance Repair': [
    {
      need_id: '149-11775',
      label: 'Convection Microwave Repair'
    },
    {
      need_id: '149-13687',
      label: 'Cooktop Repair'
    },
    {
      need_id: '149-11771',
      label: 'Dishwasher Repair'
    },
    {
      need_id: '149-13689',
      label: 'Dryer Repair'
    },
    {
      need_id: '149-13685',
      label: 'Freezer Repair'
    },
    {
      need_id: '149-13692',
      label: 'Ice Maker Repair'
    },
    {
      need_id: '149-11774',
      label: 'Major Appliance Repair'
    },
    {
      need_id: '149-11776',
      label: 'Oven Repair'
    },
    {
      need_id: '149-13686',
      label: 'Range Hood Repair'
    },
    {
      need_id: '149-11778',
      label: 'Refrigerator Repair'
    },
    {
      need_id: '149-11780',
      label: 'Stove Repair'
    },
    {
      need_id: '149-11781',
      label: 'Trash Compactor Repair'
    },
    {
      need_id: '149-13734',
      label: 'Washing Machine & Dryer Repair'
    },
    {
      need_id: '149-13688',
      label: 'Water Filter Repair'
    }
  ],
  'Auto Glass': [
    {
      need_id: '517-13741',
      label: 'Auto Glass In-Shop Service'
    },
    {
      need_id: '517-13742',
      label: 'Auto Glass Mobile Service'
    },
    {
      need_id: '517-13738',
      label: 'Auto Glass Repair'
    },
    {
      need_id: '517-13739',
      label: 'Auto Glass Replacement'
    },
    {
      need_id: '517-13740',
      label: 'Auto Glass Window Tinting'
    },
    {
      need_id: '517-13750',
      label: 'Auto Mirrors'
    },
    {
      need_id: '517-13748',
      label: 'Auto Windows'
    },
    {
      need_id: '517-13336',
      label: 'Autos'
    },
    {
      need_id: '517-13755',
      label: 'Boat Glass'
    },
    {
      need_id: '517-13344',
      label: 'Bullseye'
    },
    {
      need_id: '517-13753',
      label: 'Commercial Truck Glass'
    },
    {
      need_id: '517-13347',
      label: 'Cracks'
    },
    {
      need_id: '517-13340',
      label: 'Fast Response'
    },
    {
      need_id: '517-13338',
      label: 'Heavy Equipment'
    },
    {
      need_id: '517-13334',
      label: 'Mobile Service'
    },
    {
      need_id: '517-13752',
      label: 'Motorcycle Glass'
    },
    {
      need_id: '517-13735',
      label: 'PPG ProStars'
    },
    {
      need_id: '517-13754',
      label: 'RV Glass'
    },
    {
      need_id: '517-13342',
      label: 'Rock Chips'
    },
    {
      need_id: '517-13346',
      label: 'Scratches'
    },
    {
      need_id: '517-13343',
      label: 'Star Break'
    },
    {
      need_id: '517-13337',
      label: 'Trucks'
    },
    {
      need_id: '517-13345',
      label: 'Windshields Replaced'
    }
  ],
  'Water & Fire Damage': [
    {
      need_id: '354-12524',
      label: 'Fire & Smoke Restoration'
    },
    {
      need_id: '354-12505',
      label: 'Water & Flood Damage Restoration'
    }
  ],
  'Mold Remediation': [
    {
      need_id: '175-12119',
      label: 'Mold Remediation & Removal'
    }
  ],
  'Bathroom Remodeling': [
    {
      need_id: '249-12060',
      label: 'Bath Installation - Walk In, Fitter and Full Replacement'
    },
    {
      need_id: '249-12048',
      label: 'Bathroom Remodeling'
    },
    {
      need_id: '249-14785',
      label: 'Walk-In Tubs/ Walk-In Showers'
    }
  ],
  'Painters': [
    {
      need_id: '24 - 14645',
      label: 'Commercial Painting'
    },
    {
      need_id: '24 - 12133',
      label: 'Exterior Painting'
    },
    {
      need_id: '24 - 12137',
      label: 'Interior Painting'
    },
    {
      need_id: '24 - 12132',
      label: 'Staining & Sealing'
    },
    {
      need_id: '24 - 12150',
      label: 'Wallpaper Removal'
    }
  ],
  'AC Contractors': [
    {
      need_id: '584-14634',
      label: 'Air Ducts - Repair & Replace'
    },
    {
      need_id: '584-14346',
      label: 'Central Air - Cleaning & Maintenance'
    },
    {
      need_id: '584-14344',
      label: 'Central Air - New Install'
    },
    {
      need_id: '584-14345',
      label: 'Central Air - Repair'
    },
    {
      need_id: '584-14347',
      label: 'Commercial Cooling'
    },
    {
      need_id: '584-14349',
      label: 'Ductless Air Conditioning'
    },
    {
      need_id: '584-13218',
      label: 'Thermostats'
    }
  ],
  'Heating Contractors': [
    {
      need_id: '583-14359',
      label: 'Boilers and Radiators - New Install'
    },
    {
      need_id: '583-14385',
      label: 'Boilers and Radiators - Repair'
    },
    {
      need_id: '583-14357',
      label: 'Commercial Heat - New Install'
    },
    {
      need_id: '583-14358',
      label: 'Commercial Heat - Repair'
    },
    {
      need_id: '583-14352',
      label: 'Electric Heat - New Install'
    },
    {
      need_id: '583-14353',
      label: 'Electric Heat - Repair'
    },
    {
      need_id: '583-12324',
      label: 'Furnaces - New Install'
    },
    {
      need_id: '583-14386',
      label: 'Furnaces - Repair'
    },
    {
      need_id: '583-14350',
      label: 'Gas Heat - New Install'
    },
    {
      need_id: '583-14351',
      label: 'Gas Heat - Repair'
    },
    {
      need_id: '583-12326',
      label: 'Geothermal Systems'
    },
    {
      need_id: '583-12327',
      label: 'Heat Pumps - New Install'
    },
    {
      need_id: '583-14382',
      label: 'Heat Pumps - Repair'
    },
    {
      need_id: '583-10018',
      label: 'Heating - New Install'
    },
    {
      need_id: '583-14383',
      label: 'Heating - Repair'
    },
    {
      need_id: '583-14354',
      label: 'Oil Heat - New Install'
    },
    {
      need_id: '583-14355',
      label: 'Oil Heat - Repair'
    },
    {
      need_id: '583-10079',
      label: 'Radiant Floor Systems'
    }
  ],
  'Window Installers': [
    {
      need_id: '160-11855',
      label: 'Window Installation'
    },
    {
      need_id: '160-11854',
      label: 'Window Replacement'
    },
    {
      need_id: '848-14597',
      label: 'Window Repair'
    }
  ],
  'Home Remodeling': [
    {
      need_id: '251 - 10988',
      label: 'Basement Remodeling'
    },
    {
      need_id: '251 - 12049',
      label: 'Drywall Installed'
    },
    {
      need_id: '251 - 14635',
      label: 'Garage Remodeling'
    },
    {
      need_id: '251 - 12051',
      label: 'Historic Restoration'
    },
    {
      need_id: '251 - 12052',
      label: 'Home Additions'
    }
  ],
  'Solar Installation': [
    {
      need_id: '483-12945',
      label: 'Service & Repair All Types of Solar Systems'
    },
    {
      need_id: '483-12942',
      label: 'Solar Energy Systems'
    },
    {
      need_id: '483-12943',
      label: 'Solar Roof Panels'
    },
    {
      need_id: '483-12946',
      label: 'Water-Heater Change Outs'
    }
  ],
  'Tree Service': [
    {
      need_id: '164-11875',
      label: 'Clean-Up'
    },
    {
      need_id: '164-11876',
      label: 'Commercial Tree Service'
    },
    {
      need_id: '164-11878',
      label: 'Expert Tree Care'
    },
    {
      need_id: '164-14648',
      label: 'Residential Tree Service'
    },
    {
      need_id: '164-11881',
      label: 'Tree Bracing and Cabling'
    },
    {
      need_id: '164-11882',
      label: 'Tree Planting'
    },
    {
      need_id: '164-11883',
      label: 'Tree Pruning and Shaping'
    },
    {
      need_id: '164-11884',
      label: 'Tree Removal'
    },
    {
      need_id: '164-11885',
      label: 'Tree Stump Removal'
    }
  ],
  'Siding Contractors': [
    {
      need_id: '177-11963',
      label: 'New Siding Install - Aluminum Siding'
    },
    {
      need_id: '177-14508',
      label: 'New Siding Install - Fiber Cement - Hardie Plank'
    },
    {
      need_id: '177-11964',
      label: 'New Siding Install - Seamless Siding'
    },
    {
      need_id: '177-11965',
      label: 'New Siding Install - Shake Siding'
    },
    {
      need_id: '177-11967',
      label: 'New Siding Install - Stone Veneer'
    },
    {
      need_id: '177-11968',
      label: 'New Siding Install - Vinyl Siding'
    },
    {
      need_id: '177-11969',
      label: 'New Siding Install - Wood Siding'
    },
    {
      need_id: '177-14578',
      label: 'Siding Repair - Aluminum Siding'
    },
    {
      need_id: '177-14577',
      label: 'Siding Repair - Fiber Cement - Hardie Plank'
    },
    {
      need_id: '177-14579',
      label: 'Siding Repair - Seamless Siding'
    },
    {
      need_id: '177-14580',
      label: 'Siding Repair - Shake Siding'
    },
    {
      need_id: '177-14581',
      label: 'Siding Repair - Stone Veneer'
    },
    {
      need_id: '177-14583',
      label: 'Siding Repair - Vinyl Siding'
    },
    {
      need_id: '177-14584',
      label: 'Siding Repair - Wood Siding'
    }
  ],
  'Drains': [
    {
      need_id: '10000-10017',
      label: 'Drain Cleaning/Unclogging'
    },
    {
      need_id: '10000-10049',
      label: 'Floor & Laundry Drains'
    },
    {
      need_id: '10000-10050',
      label: 'Frozen Pipes & Drains Thawed'
    },
    {
      need_id: '10000-14362',
      label: 'General Plumbing Repair'
    },
    {
      need_id: '10000-10074',
      label: 'In-line Video Camera Service'
    },
    {
      need_id: '10000-10054',
      label: 'Leaks Detected & Repaired'
    },
    {
      need_id: '10000-10055',
      label: 'Pipe Replacements & Repairs'
    },
    {
      need_id: '10000-10077',
      label: 'Plumbing for Mobile Homes'
    },
    {
      need_id: '10000-10057',
      label: 'Sewer Lines'
    },
    {
      need_id: '10000-10058',
      label: 'Showers & Tubs'
    },
    {
      need_id: '10000-10059',
      label: 'Sinks, Toilets & Faucets'
    },
    {
      need_id: '10000-10085',
      label: 'Underground Pipe Repairs'
    }
  ],
  'Garbage Disposal': [
    {
      need_id: '10000-10017',
      label: 'Drain Cleaning/Unclogging'
    },
    {
      need_id: '10000-10048',
      label: 'Fixtures Installed'
    },
    {
      need_id: '10000-10051',
      label: 'Garbage Disposals'
    },
    {
      need_id: '10000-14362',
      label: 'General Plumbing Repair'
    },
    {
      need_id: '10000-10074',
      label: 'In-line Video Camera Service'
    },
    {
      need_id: '10000-10054',
      label: 'Leaks Detected & Repaired'
    },
    {
      need_id: '10000-10077',
      label: 'Plumbing for Mobile Homes'
    },
    {
      need_id: '10000-10057',
      label: 'Sewer Lines'
    },
    {
      need_id: '10000-10059',
      label: 'Sinks, Toilets & Faucets'
    }
  ],
  'Landscapers': [
    {
      need_id: '20-14720',
      label: 'Commercial Landscaping'
    },
    {
      need_id: '20-14718',
      label: 'Fertilization'
    },
    {
      need_id: '20-14636',
      label: 'Full Service Landscaping'
    },
    {
      need_id: '20-14716',
      label: 'Irrigation'
    },
    {
      need_id: '20-12081',
      label: 'Lawn Repair/Seeding'
    },
    {
      need_id: '20-14717',
      label: 'Lighting Installation'
    },
    {
      need_id: '20-12085',
      label: 'New Lawns - Sod or Seed'
    },
    {
      need_id: '20-12088',
      label: 'Professional Landscape Design'
    },
    {
      need_id: '20-14719',
      label: 'Residential Landscaping'
    },
    {
      need_id: '20-12089',
      label: 'Shrubbery & Flower Planting'
    },
    {
      need_id: '20-12091',
      label: 'Top Soil/Mulching'
    },
    {
      need_id: '20-12093',
      label: 'Water Features (e.g., fountains, ponds, etc)'
    }
  ]
};
